<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="internships-administrators"
            :items="tableData"
            :fields="internshipFields"
            :show-empty="true">
            <template v-slot:options>
                <b-button
                    class="btn-add btn-add-internship"
                    type="button"
                    variant="primary"
                    :label="$t('internship.new_internship')"
                    @click="createInternship()">
                    {{ $t('internship.new_internship') }}
                </b-button>
            </template>

            <template v-slot:cell(action)="data">
                <div class="actions">
                    <b-button
                        class="btn-edit btn-edit-internship btn-"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('internship.edit_internship')"
                        @click="editInternship(data.item.id)">
                    </b-button>
                    <b-button
                        class="btn-remove btn-remove-internship"
                        v-b-tooltip.hover
                        variant="danger-icon-only"
                        :title="$t('common.delete')"
                        @click="removeInternship(data.item.id)">
                    </b-button>
                </div>
            </template>

            <template #empty="scope">
                <div class="not-found with-header attachments-list">
                    <div class="icon">
                        <i class="fas fa-exclamation-circle"></i>
                    </div>
                    <div class="alert-notice">{{ $t('internship.no_internships_found') }}</div>
                </div>
            </template>
        </design-2021-apprentice-data-table>

        <design-2021-internships-create-modal-component
            :internship-tags-in="internshipTagsIn"
            :internship-duration-tags-in="internshipDurationTagsIn">
        </design-2021-internships-create-modal-component>
        <design-2021-internships-edit-modal-component
            ref="editInternshipModal"
            :internship-tags-in="internshipTagsIn"
            :internship-duration-tags-in="internshipDurationTagsIn">
        </design-2021-internships-edit-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-internships-index-school-tab-component',
    props: {
        internshipsIn: {
            type: Array,
            required: true,
        },

        internshipTagsIn: {
            type: Array,
            required: true,
        },
        internshipDurationTagsIn: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            internshipFields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'tags',
                    label: this.$t('internship.internship_type'),
                },
                {
                    key: 'location',
                    label: this.$t('common.city'),
                },
                {
                    key: 'placements',
                    label: this.$t('internship.amount_of_places'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },

    computed: {
        tableData() {
            return this.internshipsIn.map((internship) => {
                return {
                    id: internship.id,
                    name: internship.name,
                    location: internship.location,
                    placements: internship.placements,
                    owner: internship.organization,
                    tags: internship.internship_tags.map((tag) => tag.name).join(', '),
                };
            });
        },
    },

    methods: {
        createInternship() {
            this.$bvModal.show('create-internship-modal');
        },

        editInternship(id) {
            let internship = this.internshipsIn.filter((internship) => internship.id === id);
            this.$refs.editInternshipModal.show(...internship);
        },
        removeInternship(id) {
            this.alert
                .confirm(
                    this.$t('internship.delete_internship_position'),
                    this.$t('internship.are_you_sure_you_want_to_delete_this_internship_place'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.axios.delete(this.routes.internshipDelete(id)).then(
                        (response) => {
                            const internship = this.internshipsIn.find((internship) => internship.id === id);
                            internship.remove();
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
    },
};
</script>

<style scoped lang="scss">
.actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    column-gap: map-get($grid-gutter-spacing, 'fifteen');

    button {
        &:before {
            margin: 0;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .internships-administrators ::v-deep {
        .apprentice-table-header {
            flex-direction: row;

            .apprentice-table-filters {
                flex: 1 1 auto;
                margin-bottom: 0;
            }

            .options {
                margin-left: auto;
                justify-content: flex-end;
                flex: 1 1 auto;
            }
        }
    }
}
</style>
